/**
 * Shared SATCHEL state: credentials, balances and polling, from the
 * SatchelWalletProvider above the caller.
 */

import { type SatchelWalletContextValue, useSatchelWalletContext } from "./SatchelWalletContext";

export type SatchelWalletHook = SatchelWalletContextValue;

export const useSatchelWallet = (): SatchelWalletHook => useSatchelWalletContext();
